import React, { useState, useEffect } from 'react';
import api from '../utils/api';

const C = { navy:'#0D1B2A', teal:'#00B4D8', success:'#10B981', error:'#EF4444', grey:'#6B7280', border:'#E5E7EB', bg:'#F0F7FA', amber:'#F59E0B' };

const TEST_ICONS = { ielts:'🎓', cefr:'📊', sat:'📐', presidential:'🏛️' };
const TEST_COLORS = { ielts: C.teal, cefr:'#7C3AED', sat: C.amber, presidential: C.success };

function BookingModal({ testType, slots, subdomain, onClose, onBooked }) {
  const [step, setStep] = useState(1); // 1=details, 2=slot, 3=confirm
  const [form, setForm] = useState({ student_name:'', student_email:'', student_phone:'' });
  const [selectedSlot, setSelectedSlot] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  const testSlots = slots.filter(s => s.test_type_id === testType.id);

  const submit = async () => {
    if (!form.student_name || !form.student_email) { setError('Name and email are required'); return; }
    setSubmitting(true);
    setError('');
    try {
      await api.post('/api/public/mock-tests/book', {
        subdomain,
        test_type_id: testType.id,
        slot_id: selectedSlot?.id || null,
        ...form,
        payment_method: 'cash',
      });
      onBooked();
    } catch (e) { setError(e.response?.data?.error || 'Booking failed. Please try again.'); }
    setSubmitting(false);
  };

  return (
    <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.6)', display:'flex', alignItems:'center', justifyContent:'center', zIndex: 1000, padding: 20 }}>
      <div style={{ background:'#fff', borderRadius: 20, padding: 32, width:'100%', maxWidth: 520, boxShadow:'0 20px 60px rgba(0,0,0,0.3)', maxHeight:'90vh', overflowY:'auto' }}>
        {/* Header */}
        <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', marginBottom: 24 }}>
          <div>
            <div style={{ fontSize: 28 }}>{TEST_ICONS[testType.slug]}</div>
            <h2 style={{ margin:'8px 0 0', color: C.navy, fontSize: 20, fontWeight: 800 }}>Book {testType.name}</h2>
            <div style={{ color: C.teal, fontWeight: 700, fontSize: 18, marginTop: 4 }}>${testType.price_usd} per sitting</div>
          </div>
          <button onClick={onClose} style={{ background:'none', border:'none', cursor:'pointer', fontSize: 24, color: C.grey, padding: 4 }}>×</button>
        </div>

        {/* Step 1: Details */}
        {step === 1 && (
          <>
            <p style={{ color: C.grey, fontSize: 13, marginBottom: 20 }}>Please enter your details. Payment is made at the centre on test day.</p>
            {[
              { label:'Full Name *', key:'student_name', type:'text', placeholder:'e.g. Aisha Karimova' },
              { label:'Email Address *', key:'student_email', type:'email', placeholder:'your@email.com' },
              { label:'Phone Number', key:'student_phone', type:'tel', placeholder:'+998 90 123 45 67' },
            ].map(f => (
              <div key={f.key} style={{ marginBottom: 16 }}>
                <label style={{ fontSize: 13, fontWeight: 600, color: C.navy, display:'block', marginBottom: 6 }}>{f.label}</label>
                <input type={f.type} placeholder={f.placeholder} value={form[f.key]} onChange={e => setForm(p => ({...p, [f.key]: e.target.value}))}
                  style={{ width:'100%', padding:'12px 14px', borderRadius: 10, border:`1.5px solid ${C.border}`, fontSize: 14, boxSizing:'border-box', outline:'none' }} />
              </div>
            ))}
            {error && <div style={{ color: C.error, fontSize: 13, marginBottom: 12 }}>{error}</div>}
            <button onClick={() => { if (!form.student_name || !form.student_email) { setError('Name and email are required'); return; } setError(''); setStep(2); }}
              style={{ width:'100%', padding:'13px', borderRadius: 12, background: C.teal, color:'#fff', border:'none', cursor:'pointer', fontSize: 15, fontWeight: 700, marginTop: 4 }}>
              Choose a Time Slot →
            </button>
          </>
        )}

        {/* Step 2: Slot selection */}
        {step === 2 && (
          <>
            <p style={{ color: C.grey, fontSize: 13, marginBottom: 16 }}>Select your preferred test date and time, or book without a slot and we will contact you.</p>
            <div style={{ display:'flex', flexDirection:'column', gap: 10, marginBottom: 20 }}>
              {testSlots.length === 0 && (
                <div style={{ padding: 16, background: C.bg, borderRadius: 10, color: C.grey, fontSize: 13, textAlign:'center' }}>
                  No upcoming slots available at the moment. We will contact you to arrange a time.
                </div>
              )}
              {testSlots.map(s => (
                <button key={s.id} onClick={() => setSelectedSlot(s)} style={{
                  padding:'14px 16px', borderRadius: 12, border:`2px solid ${selectedSlot?.id === s.id ? C.teal : C.border}`,
                  background: selectedSlot?.id === s.id ? '#EBF9FD' : '#fff', cursor:'pointer', textAlign:'left', transition:'all 0.15s',
                }}>
                  <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center' }}>
                    <div>
                      <div style={{ fontWeight: 700, color: C.navy, fontSize: 14 }}>
                        {new Date(s.slot_date + 'T00:00:00').toLocaleDateString('en-GB', { weekday:'long', day:'numeric', month:'long' })}
                      </div>
                      <div style={{ fontSize: 13, color: C.grey, marginTop: 2 }}>
                        {s.slot_time} · {s.duration_minutes} min · {s.room_location || 'Talk2Talk Centre'}
                      </div>
                    </div>
                    <div style={{ textAlign:'right' }}>
                      <div style={{ fontSize: 13, color: s.available > 3 ? C.success : s.available > 0 ? C.amber : C.error, fontWeight: 600 }}>
                        {s.available} seats left
                      </div>
                    </div>
                  </div>
                </button>
              ))}
            </div>
            <div style={{ display:'flex', gap: 10 }}>
              <button onClick={() => setStep(1)} style={{ flex:1, padding:'12px', borderRadius: 12, border:`1px solid ${C.border}`, background:'#fff', cursor:'pointer', fontSize: 14, fontWeight: 600 }}>← Back</button>
              <button onClick={() => setStep(3)} style={{ flex:2, padding:'12px', borderRadius: 12, background: C.teal, color:'#fff', border:'none', cursor:'pointer', fontSize: 14, fontWeight: 700 }}>
                {selectedSlot ? 'Confirm Slot →' : 'Book Without Slot →'}
              </button>
            </div>
          </>
        )}

        {/* Step 3: Confirm */}
        {step === 3 && (
          <>
            <div style={{ background: C.bg, borderRadius: 12, padding: 20, marginBottom: 20 }}>
              <div style={{ fontWeight: 700, color: C.navy, marginBottom: 12, fontSize: 15 }}>Booking Summary</div>
              {[
                { label:'Test', value: testType.name },
                { label:'Name', value: form.student_name },
                { label:'Email', value: form.student_email },
                { label:'Phone', value: form.student_phone || '—' },
                { label:'Date & Time', value: selectedSlot ? `${selectedSlot.slot_date} at ${selectedSlot.slot_time}` : 'To be arranged' },
                { label:'Price', value: `$${testType.price_usd} (pay at centre)` },
              ].map(r => (
                <div key={r.label} style={{ display:'flex', justifyContent:'space-between', padding:'6px 0', fontSize: 13, borderBottom:`1px solid ${C.border}` }}>
                  <span style={{ color: C.grey }}>{r.label}</span>
                  <span style={{ color: C.navy, fontWeight: 600 }}>{r.value}</span>
                </div>
              ))}
            </div>
            <div style={{ background:'#FEF3C7', borderRadius: 10, padding: 14, marginBottom: 20, fontSize: 12, color:'#92400E' }}>
              💡 Payment is collected at the Talk2Talk centre. You will receive a confirmation email once payment is verified and your test is activated.
            </div>
            {error && <div style={{ color: C.error, fontSize: 13, marginBottom: 12 }}>{error}</div>}
            <div style={{ display:'flex', gap: 10 }}>
              <button onClick={() => setStep(2)} style={{ flex:1, padding:'12px', borderRadius: 12, border:`1px solid ${C.border}`, background:'#fff', cursor:'pointer', fontSize: 14, fontWeight: 600 }}>← Back</button>
              <button onClick={submit} disabled={submitting} style={{ flex:2, padding:'12px', borderRadius: 12, background: C.success, color:'#fff', border:'none', cursor:'pointer', fontSize: 14, fontWeight: 700, opacity: submitting ? 0.7 : 1 }}>
                {submitting ? 'Booking...' : '✓ Confirm Booking'}
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default function MockTestsSection({ subdomain }) {
  const [testTypes, setTestTypes] = useState([]);
  const [slots, setSlots] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedTest, setSelectedTest] = useState(null);
  const [booked, setBooked] = useState(false);

  useEffect(() => {
    if (!subdomain) return;
    Promise.all([
      api.get(`/api/public/mock-tests/types?subdomain=${subdomain}`),
      api.get(`/api/public/mock-tests/slots?subdomain=${subdomain}`),
    ]).then(([t, s]) => {
      setTestTypes(t.data || []);
      setSlots(s.data || []);
    }).catch(() => {}).finally(() => setLoading(false));
  }, [subdomain]);

  if (loading) return null;
  if (testTypes.length === 0) return null;

  if (booked) return (
    <div style={{ padding:'60px 20px', textAlign:'center', background:'#fff' }}>
      <div style={{ fontSize: 60, marginBottom: 16 }}>✅</div>
      <h2 style={{ color: C.navy, fontSize: 24, fontWeight: 800, marginBottom: 8 }}>Booking Received!</h2>
      <p style={{ color: C.grey, fontSize: 15, maxWidth: 480, margin:'0 auto 24px' }}>
        Your mock test booking has been submitted. Please visit the Talk2Talk centre to pay and confirm your place.
        You will receive a confirmation once payment is verified.
      </p>
      <button onClick={() => setBooked(false)} style={{ padding:'12px 32px', borderRadius: 12, background: C.teal, color:'#fff', border:'none', cursor:'pointer', fontSize: 14, fontWeight: 700 }}>
        Book Another Test
      </button>
    </div>
  );

  return (
    <div style={{ background:'#fff', padding:'60px 20px' }}>
      <div style={{ maxWidth: 1100, margin:'0 auto' }}>
        {/* Section header */}
        <div style={{ textAlign:'center', marginBottom: 48 }}>
          <div style={{ display:'inline-block', background:'#EBF9FD', color: C.teal, fontSize: 12, fontWeight: 700, padding:'6px 18px', borderRadius: 20, letterSpacing: 1, textTransform:'uppercase', marginBottom: 14 }}>
            Mock Tests
          </div>
          <h2 style={{ fontSize: 36, fontWeight: 900, color: C.navy, margin:'0 0 14px' }}>
            Prepare for Your Real Exam
          </h2>
          <p style={{ color: C.grey, fontSize: 16, maxWidth: 560, margin:'0 auto' }}>
            Take official-format mock tests at our centre before the real thing. Get your score, section breakdown, and a certificate.
          </p>
        </div>

        {/* Test cards */}
        <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fit, minmax(250px, 1fr))', gap: 24, marginBottom: 48 }}>
          {testTypes.map(tt => {
            const color = TEST_COLORS[tt.slug] || C.teal;
            const upcomingSlots = slots.filter(s => s.test_type_id === tt.id);
            return (
              <div key={tt.id} style={{ borderRadius: 16, border:`1px solid ${C.border}`, overflow:'hidden', background:'#fff', boxShadow:'0 4px 20px rgba(0,0,0,0.06)', transition:'transform 0.2s, box-shadow 0.2s', cursor:'default' }}
                onMouseEnter={e => { e.currentTarget.style.transform='translateY(-4px)'; e.currentTarget.style.boxShadow='0 12px 32px rgba(0,0,0,0.12)'; }}
                onMouseLeave={e => { e.currentTarget.style.transform='translateY(0)'; e.currentTarget.style.boxShadow='0 4px 20px rgba(0,0,0,0.06)'; }}>
                {/* Color bar */}
                <div style={{ height: 6, background: color }} />
                <div style={{ padding: 24 }}>
                  <div style={{ fontSize: 36, marginBottom: 10 }}>{TEST_ICONS[tt.slug] || '📝'}</div>
                  <h3 style={{ margin:'0 0 6px', color: C.navy, fontSize: 17, fontWeight: 800 }}>{tt.name}</h3>
                  <p style={{ color: C.grey, fontSize: 12, lineHeight: 1.5, marginBottom: 16, minHeight: 48 }}>{tt.description}</p>

                  {/* Sections */}
                  <div style={{ display:'flex', flexWrap:'wrap', gap: 4, marginBottom: 16 }}>
                    {(tt.sections || []).map(s => (
                      <span key={s} style={{ background: C.bg, color: C.navy, fontSize: 10, fontWeight: 600, padding:'3px 10px', borderRadius: 12, textTransform:'capitalize' }}>
                        {s.replace(/_/g,' ')}
                      </span>
                    ))}
                  </div>

                  {/* Duration + Price */}
                  <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom: 16 }}>
                    <span style={{ fontSize: 13, color: C.grey }}>⏱ {tt.duration_minutes} min</span>
                    <span style={{ fontSize: 22, fontWeight: 800, color }}>
                      ${tt.price_usd}
                    </span>
                  </div>

                  {/* Next slot */}
                  {upcomingSlots.length > 0 && (
                    <div style={{ background: C.bg, borderRadius: 8, padding:'8px 12px', marginBottom: 14, fontSize: 12, color: C.navy }}>
                      📅 Next: {new Date(upcomingSlots[0].slot_date + 'T00:00:00').toLocaleDateString('en-GB', { day:'numeric', month:'short' })} at {upcomingSlots[0].slot_time} · {upcomingSlots[0].available} seats
                    </div>
                  )}

                  <button onClick={() => { window.location.href = '/register'; }} style={{ width:'100%', padding:'12px', borderRadius: 10, background: color, color:'#fff', border:'none', cursor:'pointer', fontSize: 14, fontWeight: 700, transition:'opacity 0.15s' }}
                    onMouseEnter={e => e.target.style.opacity='0.9'} onMouseLeave={e => e.target.style.opacity='1'}>
                    Register to Book →
                  </button>
                </div>
              </div>
            );
          })}
        </div>

        {/* What to expect */}
        <div style={{ background: C.bg, borderRadius: 16, padding: 32, textAlign:'center' }}>
          <h3 style={{ color: C.navy, fontSize: 20, fontWeight: 800, marginBottom: 24 }}>What Happens on Test Day</h3>
          <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fit, minmax(180px, 1fr))', gap: 20 }}>
            {[
              { step:'1', icon:'📋', title:'Book & Pay', desc:'Book online, pay at the centre before your test starts.' },
              { step:'2', icon:'🆔', title:'Show Your ID', desc:'Bring a valid ID on test day. Staff will check you in.' },
              { step:'3', icon:'💻', title:'Take the Test', desc:'Full-screen timed test on our centre computers. No phones.' },
              { step:'4', icon:'📄', title:'Get Certificate', desc:'Download your results and certificate immediately after marking.' },
            ].map(s => (
              <div key={s.step} style={{ padding: 16 }}>
                <div style={{ fontSize: 32, marginBottom: 10 }}>{s.icon}</div>
                <div style={{ fontWeight: 700, color: C.navy, fontSize: 14, marginBottom: 6 }}>{s.title}</div>
                <div style={{ fontSize: 12, color: C.grey, lineHeight: 1.5 }}>{s.desc}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Booking Modal */}
      {selectedTest && (
        <BookingModal
          testType={selectedTest}
          slots={slots}
          subdomain={subdomain}
          onClose={() => setSelectedTest(null)}
          onBooked={() => { setSelectedTest(null); setBooked(true); }}
        />
      )}
    </div>
  );
}
